import axios from "axios";

export const Adminlogin = async ({email,password}) => {
    try {
        
        const response = await axios.post(
            "https://journalapi.rhc.ac.ir/Admin/login",
            {
                email: email,
                password: password,
  
            },
        );
       
        localStorage.setItem("token", response.data.meta.token);
       console.log(response.data.meta.token );
       return response.data ;
      
    } catch (error) {
        
        return {error} ;

    }
};


